import { render, staticRenderFns } from "./ClientMiniForm.vue?vue&type=template&id=1efacc31&"
import script from "./ClientMiniForm.vue?vue&type=script&lang=js&"
export * from "./ClientMiniForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports